import { render } from "./theme23.vue?vue&type=template&id=02b1d60e&scoped=true"
import script from "./theme23.vue?vue&type=script&lang=js"
export * from "./theme23.vue?vue&type=script&lang=js"

import "./theme23.vue?vue&type=style&index=0&id=02b1d60e&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-02b1d60e"

export default script